import StuckStationBanner from "./StuckStationBanner";
import SilentStationBanner from "./SilentStationBanner";
import RingMovedOnBanner from "./RingMovedOnBanner";
import MissingSignatureBanner from "./MissingSignatureBanner";
import NoVenueTimezoneBanner from "./NoVenueTimezoneBanner";

// The one stack of banners the Station Monitor page and its dashboard strip
// both render above their content, so the two can never disagree about which
// warnings exist. A new banner (e.g. #3455's missing venue timezone) is one
// more line here, and both surfaces get it.
//   - StuckStationBanner (#3427) is driven by the station-monitor `rows`.
//   - SilentStationBanner (#3475) is driven by the same `rows` (the server's
//     `watchSilence` verdict plus the shared 2 minute classifier).
//   - RingMovedOnBanner (#3476) is driven by the same `rows` (the server's
//     per-station `ringMovedOn` list).
//   - MissingSignatureBanner (#3454) loads its own data for `showId`.
//   - NoVenueTimezoneBanner (#3455) reads the active show from context.
//
// #3646: `compact` (the dashboard) renders each banner as ONE exception line
// instead; the Station Monitor page passes nothing and renders the full banners.
export default function StationMonitorBanners({ showId, rows, compact = false }) {
  return (
    <>
      <StuckStationBanner rows={rows} compact={compact} />
      <SilentStationBanner rows={rows} compact={compact} />
      <RingMovedOnBanner rows={rows} compact={compact} />
      <MissingSignatureBanner showId={showId} compact={compact} />
      <NoVenueTimezoneBanner compact={compact} />
    </>
  );
}
